import {BaseKey} from '@refinedev/core';
import React from 'react';

export type ConversableObject = {
  owner_type: string;
  owner_id: BaseKey;
};

export type ConversationContextType = ConversableObject & {
  conversations?: any[];
  activeConversation?: any;
  setActiveConversation?: (conversation: any) => void;
  refetchConversations?: () => void;
  refetchMessages?: () => void;
};

export const ConversationContext = React.createContext<ConversationContextType>({
  owner_id: 0,
  owner_type: '',
});
